import React, { Component } from 'react'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import Scroll from 'react-scroll'
import Link from '@components/Link'

import FAQ from './FAQDropdown'
import s from './CoronaTerms.css'

let Element = Scroll.Element
class CoronaTerms extends Component {
  componentDidMount() {

  }

  render() {
    const faq = [
      {
        id: 1,
        q: 'Bagaimana Cara Melakukan Donasi dengan Paket CORONA CARE MOLA TV',
        a: 'Anda cukup mengaktifkan Paket <b>CORONA CARE MOLA TV</b> yang tersedia dalam <i>platform</i> (<i>website</i> dan <i>mobile application</i>) MOLA TV. Dengan mengaktifkan Paket <b>CORONA CARE MOLA TV</b>, Anda akan mendapatkan akses <i>Premium Subscription</i> selama periode yang disebutkan pada Paket tersebut, sekaligus mendonasikan seluruh donasi tersebut kepada BNPB/GTPP Covid-19 dan PMI Pusat.'
      },
      {
        id: 2,
        q: 'Berapakah Jumlah Nominal/Denominasi Donasi pada Paket CORONA CARE MOLA TV?',
        a: 'Paket <b>CORONA CARE MOLA TV</b> tersedia dalam nominal Rp 10.000,-, Rp 20.000,-, Rp 50.000,-, Rp 100.000,- , Rp 250.000,-, Rp 500.000,-, Rp 1.000.000,-, Rp 2.000.000,- dan Rp 5.000.000,-.'
      },
      {
        id: 3,
        q: 'Apakah Pelanggan Bisa Memberikan Donasi dengan Nominal Selain yang Ditentukan pada Paket CORONA CARE MOLA TV (custom), Baik Lebih Besar Maupun Lebih Kecil?',
        a: 'Anda tidak bisa memberikan donasi dengan jumlah nominal/denominasi selain yang disebutkan di atas, melainkan hanya bisa memilih sesuai dengan nominal/denominasi yang tersedia.'
      },
      {
        id: 4,
        q: 'Apakah 1 Akun Bisa Memberikan Lebih dari 1 Kali Donasi?',
        a: 'Setiap akun dapat memberikan donasi maksimal sebanyak 1 (satu) kali per masing-masing nominal Paket per bulannya.'
      },
      {
        id: 5,
        q: 'Metode Pembayaran Apa Saja yang Tersedia untuk Melakukan Donasi?',
        a: 'Anda dapat melakukan donasi dengan metode pembayaran Virtual Account BCA, kartu kredit dan melalui transfer antar Bank lain (jaringan prima/ATM Bersama/Alto/Bank Permata). Khusus untuk pembayaran melalui BCA, Anda dapat menggunakan ATM, Mobile Banking, Internet Banking maupun Teller Bank.'
      },
      {
        id: 6,
        q: 'Apakah Ada Notifikasi Jika Anda Sudah Berhasil Melakukan Donasi?',
        a: 'Kami akan mengirimkan notifikasi melalui email setelah Anda melakukan donasi. Namun, untuk memastikan hal tersebut Anda dapat melakukan pengecekan secara mandiri melalui menu profile di aplikasi MOLA TV apakah Paket <b>CORONA CARE MOLA TV</b> telah aktif.'
      },
      {
        id: 7,
        q: 'Tayangan Apa Saja yang Termasuk ke Dalam Paket CORONA CARE MOLA TV?',
        a: 'Seluruh tayangan Mola TV, Originals, Kids dan Movies.'
      },
      {
        id: 8,
        q: 'Paket CORONA CARE MOLA TV Berlaku untuk Berapa Lama?',
        a: 'Masa aktif Paket tersebut adalah selama 1 (satu) bulan. Perpanjangan masa aktif dapat dilakukan dengan cara mengaktifkan kembali Paket yang Anda inginkan.'
      },
      {
        id: 9,
        q: 'Kemana dan Berapa Banyak Donasi dari Anda yang Akan Disalurkan?',
        a: 'Seluruh donasi yang terkumpul dari Paket <b>CORONA CARE MOLA TV</b> akan disalurkan sepenuhnya kepada BNPB/GTPP Covid-19 dan PMI Pusat. Selain itu, MOLA TV juga akan menambahkan dengan dana internal MOLA TV minimal sama dengan atau dengan pagu tertentu yang setara dengan hasil seluruh donasi yang terkumpul.'
      },
      {
        id: 10,
        q: 'Kapan Donasi dari Anda akan Disalurkan?',
        a: 'Seluruh donasi yang telah terkumpul melalui MOLA TV akan disalurkan secara bertahap kepada BNPB / GTPP Covid-19 dan PMI Pusat melalui rekening resmi dari BNPB / GTPP Covid-19 dan PMI Pusat selama program Paket <b>CORONA CARE MOLA TV</b> berlangsung.'
      }
    ]

    const { backToApps } = this.props

    return (
      <div className={s.container_bg}>
        <div className={s.container_center}>
          <Element name={'terms'}>
            <div className={s.content_container}>
              <div className={s.title}>
                <span />
                <p>SYARAT DAN KETENTUAN CORONA CARE MOLA TV</p>
              </div>
              <p>Sebagai bentuk partisipasi MOLA TV untuk membantu upaya Pemerintah Republik Indonesia dalam menanggulangi pandemi Novel Corona Virus COVID-19, MOLA TV menyediakan donasi melalui program <b>CORONA CARE MOLA TV</b>. Bagi para calon pelanggan ataupun pelanggan yang ingin memberikan donasi melalui program <b>CORONA CARE MOLA TV</b> dapat mengaktifkan paket <b>CORONA CARE MOLA TV</b>. Keseluruhan donasi yang terkumpul akan disalurkan kepada masyarakat di Indonesia yang terdampak atas pandemi tersebut.</p>
              <p>Bahwa program <b>CORONA CARE MOLA TV</b> tersebut dilaksanakan oleh MOLA TV melalui kerjasama dengan Badan Nasional Penanggulangan Bencana (BNPB)/Gugus Tugas Percepatan Penanganan Corona Virus Disease (Covid-19) (GTPP Covid-19) dan Palang Merah Indonesia (PMI) Pusat untuk menyalurkan bantuan dana yang terkumpul tersebut di atas kepada masyarakat di Indonesia yang terdampak atas pandemi tersebut.</p>
              <p>Pelaksanaan program <b>CORONA CARE MOLA TV</b> ini tunduk dan patuh terhadap
              <Link to={`/terms${backToApps ? '?noHeader=1' : ''}`}> Syarat</Link>,
              <Link to={`/conditions${backToApps ? '?noHeader=1' : ''}`}> Ketentuan</Link> dan
              <Link to={`/privacy${backToApps ? '?noHeader=1' : ''}`}> Kebijakan Privasi</Link>.</p>
              <p className={s.highlight}>Seluruh donasi yang telah disalurkan oleh MOLA TV kepada badan-badan tersebut sepenuhnya merupakan tanggung jawab dan wewenang badan-badan tersebut untuk dipergunakan dan disalurkan kepada masyarakat di Indonesia yang membutuhkan. MOLA TV hanya berperan sebagai penghubung antara Anda dan badan-badan tersebut yang akan menerima donasi dari Anda.</p>
            </div>
          </Element>
          <Element name={'faq'}>
            <div className={s.content_container}>
              <div className={s.title}>
                <span />
                <p>(FAQ) FREQUENTLY ASKED QUESTIONS</p>
              </div>
              <div className={s.content_inner}>
                {
                  faq.map((dt) => {
                    return (
                      <FAQ key={dt.id} id={dt.id} question={dt.q} answer={dt.a} />
                    )
                  })
                }
              </div>
            </div>
          </Element>
        </div>
      </div>
    )
  }
}

export default withStyles(s)(CoronaTerms)
